export const environment = {
  production: false,
  type:'DEV',
  contextIsRoot: false,
  requestPaymentLink:'https://www3dev.wipo.int/amc-payment/dcti-request-form',
  answerPaymentLink:'https://www3dev.wipo.int/amc-payment/dcti-answer-form',
  webComponentsPath: 'https://cdn.ipp-navbar.ipportal.dev.web1.wipo.int',
  apiUrl: 'https://web.amc-arbmed.arb.dev.web1.wipo.int/',
  recaptchaSiteKey: '6Lf-k-csAAAAAFMtaR_pYy83KB6n-kmxqoQcISBS',
  cookieDomain: 'web.amc-arbmed.arb.dev.web1.wipo.int',
  languageQueryParamName: 'lang',
  siteUrl: 'https://web.amc-arbmed.arb.dev.web1.wipo.int/',
  hostName: window.location.origin ,

  /* Quicksight Integration */
  quicksightIntegrationEnabled: true,


  /* Authentication settings */
  oidcUserinfo: '/am/oauth2/userinfo',
  oidcIssuer: 'https://logindev.wipo.int:443/am/oauth2',
  oidcClientId: 'amcFormsDev',
  oidcRedirectUri: window.location.origin + '/login',
  oidcPostLogoutRedirectUri: 'https://logindev.wipo.int/wipoaccounts/generic/public/logout.xhtml?returnURL=https://web.amc-arbmed.arb.dev.web1.wipo.int',
  oidcSilentRedirectUri: window.location.origin + '/silent-refresh.html',
  oidcScope: 'openid profile email',

  ssoCookieName: 'amdssocookie',
  ssoUseridUrl: 'https:/logindev.wipo.int/sso/userid',

  refreshTimeout: 0.7
};
